import { Component, ElementRef, Injector, Input, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';
import { WidgetBaseComponent } from '../../widgetBase';

/**
 * PortfolioNetRent Widget
 */
@Component({
  selector: 'portfolio-net-rent-widget',
  templateUrl: './portfolio-net-rent-widget.component.html',
  styleUrls: ['./portfolio-net-rent-widget.component.scss']
})
export class PortfolioNetRentWidgetComponent extends WidgetBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
   * Table Container Height
   */
  public tableContainerHeight = '';

  /**
   * current Layout
   */
  currentLayout = 'Net Rent | Region';

  /**
  * Constructor
  * @param el ElementRef
  */
  constructor(private el: ElementRef, injector: Injector) {
    super(injector, 'portfolioNetRent', false);
  }

  /**
   * Initializes the component
   */
  ngOnInit() {
    // will call registerEvents and onInitialized when config (this.widgetConfig and this.page) is ready
    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useReadOnlySaveChangesHandler();
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    this.mockupData$ = this.widgetService.loadEmpty();

    this.widgetData$ = this.widgetService.load('portfolioNetRentPropertyType', this.getReport());
    this.widgetData$.pipe(first()).subscribe(data => this.widgetData = data);
  }

  /**
   * widgetResized event handler
   */
  widgetResized() {
    //get height of gridster, so we can adjust chart table container height
    const gridsterEl = this.getGridsterElement(this.el);
    const height = parseInt(gridsterEl.style.height);
    this.tableContainerHeight = `${height}px`;
  }

  /**
   * Returns label content
   * @param e {any} Event object
   */
  labelContent(e: any): string {
    return `${e.category} : ${e.value}%`;
  }

  /**
   * Loads widget data
   * @param path {string} Path to load data from
   */
  private loadData(path: string) {
    this.widgetService.load(path, this.getReport()).pipe().subscribe(data => this.widgetData = data);

  }

  /**
   * Layout changed event handler
   * @param newLayout {string} New layout
   */
  public layoutChanged(newLayout: string): void {
    setTimeout(() => {
      switch (newLayout) {
        case 'Net Rent | Sector': {
          this.currentLayout = 'Net Rent | Sector';
          this.loadData('portfolioNetRentPropertyType');
          break;
        }
        case 'Net Rent | Region': {
          this.currentLayout = 'Net Rent | Region';
          this.loadData('portfolioNetRentRegion');
          break;
        }
        case 'Net Rent | Tenure': {
          this.currentLayout = 'Net Rent | Tenure';
          this.loadData('portfolioNetRentTenure');
          break;
        }
      }
    });
  }

  /**
   * Select previos layout
   */
  public selectPrevious(): void {
    this.switchLayout(-1);
  }

  /**
   * Select next layout
   */
  public selectNext(): void {
    this.switchLayout(1);
  }

  /**
   * Switch layout
   * @param offset {number} Layout offset
   */
  private switchLayout(offset: number): void {
    const layouts = ['Net Rent | Sector', 'Net Rent | Region', 'Net Rent | Tenure'];
    let layoutsCount = layouts.length;

    if (layoutsCount <= 1) {
      return;//nothing to change to
    }

    const currentLayout = this.currentLayout;
    let layoutIndex = layouts.indexOf(currentLayout) || 0;
    const layoutFound = true;
    do {
      layoutsCount--;
      layoutIndex += offset;
      layoutIndex %= layouts.length;
      if (layoutIndex < 0) {
        layoutIndex = layouts.length - 1;
      }
    }
    while (!layoutFound && layoutsCount > 0);//layoutsCount: safeguard if no layout can be chosen

    if (layoutFound) {
      this.currentLayout = layouts[layoutIndex];
      this.layoutChanged(this.currentLayout);
    }
  }
}

